export enum ActionType {
  approve = "approved",
  reject = "reject",
  publish = "publish",
  update = "update",
  delete = "delete",
  toDraft = "toDraft",
  unverify= "unverify",
  distributeWL="distributeWL",
  WalletAccess = "WalletAccess",
}
